import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const initStateAdminUnifiedActivity = {
  adminUnifiedActivity: { data: null, loading: false, error: null },
};

export const adminUnifiedActivity = createAsyncThunk(
  "payment/adminUnifiedActivity",
  async (params = {}, { rejectWithValue, fulfillWithValue }) => {
    const token = localStorage.getItem("token");
    if (!token) return rejectWithValue({ error: "Необходима авторизация" });

    return await axios
      .get(`${process.env.REACT_APP_SERVER_API}/payments/apipay/admin/unified-activity/`, {
        headers: { Authorization: `Bearer ${token}` },
        params,
      })
      .then((res) => fulfillWithValue(res.data))
      .catch((res) =>
        rejectWithValue(res.response?.data || { error: "Ошибка загрузки активности" })
      );
  }
);

export const reducerAdminUnifiedActivity = {
  [adminUnifiedActivity.pending]: (state) => {
    state.adminUnifiedActivity.loading = true;
    state.adminUnifiedActivity.error = null;
  },
  [adminUnifiedActivity.fulfilled]: (state, action) => {
    state.adminUnifiedActivity.loading = false;
    state.adminUnifiedActivity.data = action.payload;
    state.adminUnifiedActivity.error = null;
  },
  [adminUnifiedActivity.rejected]: (state, action) => {
    state.adminUnifiedActivity.loading = false;
    state.adminUnifiedActivity.data = null;
    state.adminUnifiedActivity.error = action.payload;
  },
};
